import { render, staticRenderFns } from "./ConfigTickets.vue?vue&type=template&id=d59c49b6"
import script from "./ConfigTickets.vue?vue&type=script&lang=js"
export * from "./ConfigTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports